import { InjectionToken } from '@angular/core';
import { FuseConfig } from '@fuse/services/config/config.types';

export const FUSE_CONFIG = new InjectionToken<FuseConfig>('FUSE_APP_CONFIG');
